module.exports = __webpack_public_path__ + "img/htc-logo2.f064fd32.jpeg";